import apiService from './apiService';

/**
 * Service pour les catégories de produits
 */
class CategoryService {
  /**
   * Récupère la liste des catégories avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order, is_active)
   */
  async getCategories(params = {}) {
    const response = await apiService.get('/categories', params);
    return response.data;
  }

  /**
   * Récupère une catégorie spécifique
   * @param {string} id - ID de la catégorie
   */
  async getCategory(id) {
    const response = await apiService.get(`/categories/${id}`);
    return response.data;
  }

  /**
   * Crée une nouvelle catégorie
   * @param {Object} categoryData - Données de la catégorie (name, description, parent_id, is_active, image_path)
   */
  async createCategory(categoryData) {
    const formData = new FormData();
    Object.keys(categoryData).forEach(key => {
      if (categoryData[key] !== null && categoryData[key] !== undefined) {
        formData.append(key, categoryData[key]);
      }
    });
    const response = await apiService.upload('/categories', formData);
    return response.data;
  }

  /**
   * Met à jour une catégorie
   * @param {string} id - ID de la catégorie
   * @param {Object} categoryData - Nouvelles données
   */
  async updateCategory(id, categoryData) {
    const formData = new FormData();
    Object.keys(categoryData).forEach(key => {
      if (categoryData[key] !== null && categoryData[key] !== undefined) {
        formData.append(key, categoryData[key]);
      }
    });
    const response = await apiService.putFormData(`/categories/${id}`, formData);
    return response.data;
  }

  /**
   * Supprime une catégorie
   * @param {string} id - ID de la catégorie
   */
  async deleteCategory(id) {
    return apiService.delete(`/categories/${id}`);
  }
}

const categoryServiceInstance = new CategoryService();
export default categoryServiceInstance;
